module.exports = __webpack_public_path__ + "static/media/arrowTip.4adfd964.svg";